import { Stack, Typography } from '@mui/material';
import { formatCurrency } from '../../utils/currency';
import { formatearNumeroConComas } from 'views/Components/Shared/utils/formatNumbers';
import { AppGlobalContext } from 'contexts/GlobalContext';
import { useContext } from 'react';

export default function PvpShippingCell({
	pvp,
	freeshipping,
	freeshippingCost,
}) {
	const { mainCountry } = useContext(AppGlobalContext);
	const countryName = mainCountry?.pais;

	return (
		<Stack
			spacing="4px"
			sx={{
				alignItems: 'center',
				justifyContent: 'center',
				height: '100%',
			}}
		>
			<Typography>${pvp ? formatearNumeroConComas(pvp) : '$0.00'}</Typography>
			<Typography
				sx={{
					color: '#222F5A',
					fontWeight: 500,
				}}
			>
				{formatCurrency(
					formatearNumeroConComas(freeshippingCost),
					countryName
				)}
			</Typography>
		</Stack>
	);
}
